import { cellPaddingWidth, fontSize } from './config'
import { AUTO_WIDTH } from './mixins/calculate'
// 校验中文正则
const chinessReg = /[\u4e00-\u9fa5|%]/

const chinessMark = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|@|$]/

const numReg = /[0-9]/

let numWidth = 0 // 数字宽度
let threePoint = 0 // ... 宽度

// 判断一个参数是否是未定义的，如果是undefined返回false，否则返回true
export const isDef = v => v !== undefined

// 获取数据
export const getValue = (key, obj) => {
  if (!key) {
    return ''
  }
  // 'a.b[0].c' or 'a.b[0].c[0]'
  if (key.indexOf('.') > 0) {
    let arr = key.split('.')
    let length = arr.length - 1
    return arr.reduce((s, k, i) => {
      let index = k.indexOf('[')
      if (i === length) {
        if (index > 0) {
          return (s[k.substr(0, index)] || [])[+k.substring(index + 1, k.length - 1)]
        }
        return s[k]
      } else {
        if (index > 0) {
          return (s[k.substr(0, index)] || [])[+k.substring(index + 1, k.length - 1)] || {}
        }
        return s[k] || {}
      }
    }, obj)
  }
  // 'a[0]'
  let index = key.indexOf('[')
  if (index > 0) {
    return (obj[key.substr(0, index)] || [])[+key.substring(index + 1, key.length - 1)]
  }
  return obj[key]
}

// 溢出隐藏计算
export const textOverflow = (ctx, text, width, ratio) => {
  let str = ''
  let len = 2 * cellPaddingWidth * ratio
  let over = false
  const zhWidth = fontSize * ratio // 中文
  // 测量数字和...的宽度
  if (!numWidth) {
    numWidth = Math.round(ctx.measureText('0').width * 100) / 100
    threePoint = Math.round(ctx.measureText('...').width * 100) / 100
  }
  // 字段值存在 或者为 0
  text = text || (typeof text === 'number') ? text + '' : ''
  // 文字宽度
  const tw = Math.floor(ctx.measureText(text).width) || 1
  if (text && text.length > 2 && tw > (width - len)) {
    let arr = text.split('')
    for (let i = 0, le = arr.length; i < le; i++) {
      let char = arr[i]
      if (chinessReg.test(char) || chinessMark.test(char)) {
        len += zhWidth
      } else if (numReg.test(char)) {
        len += numWidth
      } else {
        len += Math.round(ctx.measureText(char).width * 100) / 100
      }
      if (len > (width - threePoint)) {
        str += '...'
        over = true
        break
      } else {
        str += char
      }
    }
  } else {
    str = text
  }
  return {
    tw,
    over,
    text: str
  }
}

// 头部排序位置计算
export const sortPosition = (ctx, text) => {
  if (text || typeof text === 'number') {
    text = text + ''
    return Math.ceil(ctx.measureText(text).width) || text.length * fontSize
  }
  return 0
}

// 生成uuid
const ustr = () => Math.random().toString(36).substr(3)
export const createUuid = () => ustr() + ustr()

// 加载图片
export const loadImage = async url => {
  const Image = new window.Image()
  Image.src = url
  return new Promise((resolve, reject) => {
    Image.onload = () => {
      resolve(Image)
    }
    Image.onerror = err => {
      reject(err)
    }
  })
}

const strReg = /^￥/
// 转成数字
export const toNumber = num => {
  // 如果是人民币的形式, 先去掉￥ 然后在转数字
  if (strReg.test(num)) {
    num = num.substr(1).replace(',', '')
  }
  return isNaN(+num) ? 0 : +num
}

const hasTouch = 'ontouchstart' in window
const startEvent = hasTouch ? 'touchstart' : 'mousedown'
const moveEvent = hasTouch ? 'touchmove' : 'mousemove'
const endEvent = hasTouch ? 'touchend' : 'mouseup'
const cancelEvent = hasTouch ? 'touchcancel' : 'mouseup'

export const deviceEvent = {
  hasTouch,
  startEvent,
  moveEvent,
  endEvent,
  cancelEvent
}

export const getClient = e => {
  let clientX = hasTouch ? e.touches[0].clientX : e.clientX
  let clientY = hasTouch ? e.touches[0].clientY : e.clientY
  return {
    x: clientX,
    y: clientY
  }
}

// 针对devicePixelRatio = 1.25屏下的高清画线的解决方案
const pixelMap = {
  '0': 0,
  '1': 0,
  '2': 0.5,
  '3': 1,
  '-1': 0,
  '-2': -0.5,
  '-3': -1
}

export const toFixPixel = mun => window.devicePixelRatio === 1.25 ? (mun + pixelMap[`${Math.round(mun) % 4}`]) : mun

// 计算 columns中的配置中"width"设置为"auto"的实际宽度方法
export function computedAutoWidth (col, data, ctx, parentCol) {
  const { key, label, sortKeys } = col
  const Padding = 2 * cellPaddingWidth + 8
  let width = col.width // 默认为之前的配置
  // 取数据的集合
  const keyOfDataList = data.map(row => row[key]).filter(val => !!val)
  // 判断数据集合中长度最长的数据，是否考虑对象？上一步已经处理过了数据，不可能兼容所有场景
  const dataOfLength = keyOfDataList.map(val => sortPosition(ctx, val))
  // 取最长的数据
  const maxLength = (dataOfLength.length && Math.max(...dataOfLength)) || -1
  // 计算label的宽度
  let labelWidth = sortPosition(ctx, label) + Padding
  // 如果有排序，则labelWidth再添加一个值，因为画排序按钮的位置是判断 item.width > width + diff，auto的时候，可能为label的宽度，所以可能相等
  const isExitSort = sortKeys && sortKeys.length === 2
  if (isExitSort) {
    labelWidth += 8
  }
  // 最字符串数据最长的值，必须存在
  if (maxLength > -1) {
    width = maxLength + Padding || 1
    // 如果实际值小于 label, 则取label的宽度
    if (width < labelWidth) {
      width = labelWidth
    }
  } else {
    // 如果没有数据则取 label的宽度作为初始宽度
    width = labelWidth
    // 如果是二级头，则比较父级的label与子集的label，如果父级长过子集就取父级
    if (parentCol) {
      const parentLabelWidth = sortPosition(ctx, parentCol.label) + Padding
      if (width < parentLabelWidth) {
        width = parentLabelWidth
      }
    }
  }
  // 存储用户的width的配置
  col['_width'] = AUTO_WIDTH
  col['_autoWidth'] = width
  return width
}

// 更新cols的 x坐标 和 宽度 的方法
export function updateColsItem(cols, data, ctx, ratio, colWidthMap = {}) {
  // 判断是否存在 auto的宽度
  const isExitAutoWidth = cols.some(col => col._width === AUTO_WIDTH)
  // 存在则重新计算 x轴与宽度。 历史设计原因，在初始化的就使用了默认的column宽度作为 x的坐标的起点。
  if (isExitAutoWidth) { // 存在且有数据的时候
    // 新的x坐标值
    let updateX = 0
    cols.forEach((col, i) => {
      if (i > 0) {
        updateX += cols[i - 1].width
      }
      // 用户配置的字段为 'auto' 时，根据画布的数据（res）的来重新测量宽度
      if (col._width === AUTO_WIDTH) {
        col.width = colWidthMap[col.key] || computedAutoWidth(col, data, ctx) * ratio
      }
      // 更新x的值，x的值是根据width来叠加计算的
      col.x = updateX

      // 如果存在二级头，还得更新二级头的宽度
      if (col._parent && col._parent.children) {
        col._parent.children.forEach(child => {
          if (child.key === col.key) {
            child.width = col.width
          }
        })
        // 确保正确的父级计算
        const visibleChildren = col._parent.children.filter(child => !!child.show)
        // 确保是数据，不会为NaN
        const visibleChildrenWidth = visibleChildren.map(ele => ele.width).filter(num => !!Number(num)) || []
        // 确保数据正确。添加显示的子级的宽度
        col._parent.width = colWidthMap[col._parent.key] || visibleChildrenWidth.reduce((pre, cur) => (pre + cur))
      }
      if (col._pindex === 0) {
        col._parent.x = updateX
      }
    })
  }
}

export function computedExcludeSortWidth (cols, sindex) {
  let excludeSortWidth = 0
  cols.forEach((col, i) => {
    // 由于宽度可能发生改变，那么 excludeSortWidth的值也可能需要重算
    if (i < sindex) {
      excludeSortWidth += col.width
    }
  })
  return excludeSortWidth
}


export function findScrollContainer(element) {
  if (!element) {
    return null
  }
  const style = window.getComputedStyle(element)
  if (
    style.overflow === 'auto' ||
    style.overflow === 'scroll' ||
    style['overflow-y'] === 'scroll' ||
    style['overflow-y'] === 'auto'
    ) {
    return element
  }
  return findScrollContainer(element.parentElement)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/utils.js